import { Form } from 'antd'
import React from 'react'
import { CommonClient } from '~/agents/common/client'
import { OnboardingValues } from '~/agents/legalAssistant/common'
import { ProviderAccountAuthorization } from '~/features/formConfiguration/client/components/CustomInputs/ProviderAccountAuthorization'
import { SelectGooglePicker } from '~/features/formConfiguration/client/components/CustomInputs/SelectGooglePicker'
import { TitlePrimary } from '~/features/shared/components'
import { StepProps } from '../types'

type Props = StepProps

export const StepGoogleDrive: React.FC<Props> = ({ ...props }) => {
  return (
    <>
      <CommonClient.Onboarding.Step {...props}>
        <TitlePrimary level={4}>
          Choose the files you'd like to share with me
        </TitlePrimary>

        <Form.Item<OnboardingValues> shouldUpdate={true}>
          {options => {
            const providerAccountId = options.getFieldValue([
              'fileServices',
              'accountGoogleDrive',
            ])

            if (!providerAccountId) {
              return <></>
            }

            return (
              <Form.Item
                name={['googleDriveSettings', 'permissionManageFiles']}
                label="Access Drive Files"
                rules={[
                  {
                    validator: (_, value) =>
                      value?.[0]?.isCorrupted
                        ? Promise.reject()
                        : Promise.resolve(),
                    message: 'Authorization is not valid',
                  },
                ]}
              >
                <ProviderAccountAuthorization
                  providerAccountId={providerAccountId}
                  scope="https://www.googleapis.com/auth/drive.file"
                  ui={{
                    title: 'Access Drive Files',
                    iconAntd: 'GoogleOutlined',
                    description:
                      'Allow access to selected Google Drive files only',
                  }}
                />
              </Form.Item>
            )
          }}
        </Form.Item>

        <Form.Item<OnboardingValues> shouldUpdate={true}>
          {options => {
            const providerAccountId = options.getFieldValue([
              'fileServices',
              'accountGoogleDrive',
            ])

            const permission = options.getFieldValue([
              'googleDriveSettings',
              'permissionManageFiles',
            ])

            if (!permission || !providerAccountId) {
              return <></>
            }

            return (
              <Form.Item
                name={['googleDriveSettings', 'files']}
                label="Access Drive Files"
              >
                <SelectGooglePicker
                  isMultiple
                  providerAccountId={providerAccountId}
                  providerAccountScopeValues={permission}
                  buttonEmptyPlaceholder="Choose files"
                />
              </Form.Item>
            )
          }}
        </Form.Item>
      </CommonClient.Onboarding.Step>
    </>
  )
}
